import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import { Pencil, Plus } from 'lucide-react';

const customSelectStyles = {
    control: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)',
        opacity: 0.6
    }),
    input: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: 'var(--form-control-color)'
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: '14px',
        color: state.isSelected ? 'white' : 'var(--form-control-color)'
    })
};

const MODEL_KINDS = [
    { value: 'Forecasting', label: 'Forecasting' },
    { value: 'Anomaly Detection', label: 'Anomaly Detection' },
    { value: 'Classification', label: 'Classification' },
    { value: 'Regression', label: 'Regression' },
    { value: 'Optimization', label: 'Optimization' },
    { value: 'Recommendation', label: 'Recommendation' }
];

const BIZ_SVG = (
    <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g>
            <path d="M9.43582 5.9987C9.26448 5.9987 9.12137 5.9412 9.00648 5.8262C8.89148 5.71131 8.83398 5.56692 8.83398 5.39303V2.93786C8.83398 2.76386 8.89193 2.61942 9.00782 2.50453C9.12371 2.38953 9.26726 2.33203 9.43848 2.33203H13.0655C13.2368 2.33203 13.3799 2.38953 13.4948 2.50453C13.6098 2.61942 13.6673 2.76386 13.6673 2.93786V5.39303C13.6673 5.56692 13.6094 5.71131 13.4935 5.8262C13.3776 5.9412 13.234 5.9987 13.0628 5.9987H9.43582ZM2.93582 8.33203C2.76448 8.33203 2.62137 8.27453 2.50648 8.15953C2.39148 8.04453 2.33398 7.90203 2.33398 7.73203V2.93186C2.33398 2.76186 2.39193 2.61942 2.50782 2.50453C2.62371 2.38953 2.76726 2.33203 2.93848 2.33203H6.56548C6.73682 2.33203 6.87993 2.38953 6.99482 2.50453C7.10982 2.61953 7.16732 2.93203 7.16732 2.93203V7.7322C7.16732 7.9022 7.10937 8.04464 6.99348 8.15953C6.8776 8.27453 6.73404 8.33203 6.56282 8.33203H2.93582ZM9.43582 13.6654C9.26448 13.6654 9.12137 13.6079 9.00648 13.4929C8.89148 13.3779 8.83398 13.2354 8.83398 13.0654V8.2652C8.83398 8.0952 8.89193 7.95275 9.00782 7.83786C9.12371 7.72286 9.26726 7.66536 9.43848 7.66536H13.0655C13.2368 7.66536 13.3799 7.72286 13.4948 7.83786C13.6098 7.95286 13.6673 8.09536 13.6673 8.26536V13.0655C13.6673 13.2355 13.6094 13.378 13.4935 13.4929C13.3776 13.6079 13.234 13.6654 13.0628 13.6654H9.43582ZM2.93582 13.6654C2.76448 13.6654 2.62137 13.6079 2.50648 13.4929C2.39148 13.378 2.33398 13.2335 2.33398 13.0595V10.6044C2.33398 10.4305 2.39193 10.2861 2.50782 10.1712C2.62371 10.0562 2.76726 9.9987 2.93848 9.9987H6.56548C6.73682 9.9987 6.87993 10.0562 6.99482 10.1712C7.10982 10.2861 7.16732 10.4305 7.16732 10.6044V13.0595C7.16732 13.2335 7.10937 13.378 6.99348 13.4929C6.8776 13.6079 6.73404 13.6654 6.56282 13.6654H2.93582Z" fill="currentColor" />
        </g>
    </svg>
);

// const FN_SVG = (
//     <svg className='tw-block' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//         <g>
//             <path d="M3.077 12.6654C2.77011 12.6654 2.51389 12.5626 2.30833 12.357C2.10278 12.1515 2 11.8953 2 11.5884V4.40903C2 4.10214 2.10278 3.84592 2.30833 3.64036C2.51389 3.43481 2.77011 3.33203 3.077 3.33203H5.95C6.09356 3.33203 6.23311 3.36109 6.36867 3.4192C6.50411 3.47731 6.62011 3.55464 6.71667 3.6512L7.73083 4.66536H12.923C13.2299 4.66536 13.4861 4.76814 13.6917 4.9737C13.8972 5.17925 14 5.43548 14 5.74236V11.5884C14 11.8953 13.8972 12.1515 13.6917 12.357C13.4861 12.5626 13.2299 12.6654 12.923 12.6654H3.077Z" fill="currentColor" />
//         </g>
//     </svg>
// );

const IconLabel = ({ icon, label }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span className="tw-text-[#788097] dark:tw-text-white tw-shrink-0" style={{ display: 'inline-flex', alignItems: 'center' }}>
            {icon}
        </span>
        <span style={{ fontSize: '14px' }}>{label}</span>
    </div>
);

IconLabel.propTypes = {
    icon: PropTypes.element.isRequired,
    label: PropTypes.string.isRequired
};

const makeIconComponents = (icon) => ({
    Option: (props) => (
        <components.Option {...props}>
            <IconLabel icon={icon} label={props.data.label} />
        </components.Option>
    ),
    SingleValue: (props) => (
        <components.SingleValue {...props}>
            <IconLabel icon={icon} label={props.data.label} />
        </components.SingleValue>
    )
});

const bizBadgeComponents = makeIconComponents(BIZ_SVG);
// const fnBadgeComponents = makeIconComponents(FN_SVG);

class EntityModal extends React.Component {
    render() {
        const { show, onClose, onSave, entityModal, businesses, onChange } = this.props;

        const type = entityModal.type;

        return (
            <Modal 
                show={show} 
                onHide={onClose}
                dialogClassName="modal-vertical shadow" 
                className="fixed-right model__help modal-integration"
                size="xl"
            >
                <form onSubmit={(e) => { e.preventDefault(); onSave(); }} className="tw-flex tw-flex-col tw-h-full">
                    {/* Header */}
                    <Modal.Header closeButton>
                        <div className='tw-flex tw-items-center tw-gap-4'>
                            <div className='tw-flex tw-items-center tw-justify-center tw-p-[10px] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/20 tw-bg-white dark:tw-bg-white/10 tw-rounded-[10px]'>
                                {type === 'business' ? <Pencil className="tw-text-[#414651] dark:tw-text-white tw-w-5 tw-h-5" strokeWidth={2.5} /> : <Plus className="tw-text-[#414651] dark:tw-text-white tw-w-5 tw-h-5" strokeWidth={2.5} />}
                            </div>
                            <div>
                                <h5 className="modal-title !tw-mb-[2px] tw-font-semibold !tw-text-gray-900 dark:!tw-text-white">
                                    {entityModal.id ? 'Edit ' : 'Add '}
                                    {type === 'business' ? 'Business' :
                                     type === 'function' ? 'Function' :
                                     type === 'kpi' ? 'KPI' : 'Model'}
                                </h5>
                                <p className='tw-text-xs tw-font-medium tw-text-[#525252] dark:tw-text-gray-400 tw-m-0'>
                                    {type === 'business' ? 'Create a new business' :
                                     type === 'function' ? 'Create a new function' :
                                     type === 'kpi' ? 'Create a new kpi' :
                                     'Create a new model'}
                                </p>
                            </div>
                        </div>
                    </Modal.Header>

                    {/* Body */}
                    {/* Body */}
                    <Modal.Body className="tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden !tw-p-0 scr text-left tw-bg-slate-50/50 dark:tw-bg-[#1E1E2D]/50 max-h-[65vh]">
                        <div className="qd-configure-integration-steps !tw-p-5">
                            <div className="w-100">
                                    <div className="tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-white/10 tw-bg-[#FAFAFA] dark:tw-bg-white/5 tw-rounded-xl tw-p-4 tw-shadow-sm tw-space-y-4">
                                        {/* Parent Selection (Only when adding a Function) */}
                                        {!entityModal.id && type === 'function' && (
                                            <Form.Group className="tw-mb-0">
                                                <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1.5">
                                                    Parent Business
                                                </Form.Label>
                                                <Select
                                                    className="has-badge"
                                                    classNamePrefix="select-control"
                                                    placeholder="Select Business"
                                                    options={businesses.map(b => ({ value: b.id, label: b.name }))}
                                                    value={businesses.map(b => ({ value: b.id, label: b.name })).find(o => o.value === entityModal.presetParentId) || null}
                                                    onChange={opt => onChange('presetParentId', opt ? opt.value : '')}
                                                    components={bizBadgeComponents}
                                                    styles={customSelectStyles}
                                                />
                                            </Form.Group>
                                        )}

                                        {/* Name Field */}
                                        <Form.Group className="tw-mb-0">
                                            <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1">
                                                {type === 'business' ? 'Business name' :
                                                 type === 'function' ? 'Function name' :
                                                 type === 'kpi' ? 'KPI name' : 'Model name'}
                                            </Form.Label>
                                            <Form.Control 
                                                type="text"
                                                placeholder={type === 'business' ? 'e.g. Commercial' :
                                                             type === 'function' ? 'e.g. Sales Performance' :
                                                             type === 'kpi' ? 'e.g. Total Revenue' : 'e.g. Demand Forecast'}
                                                value={entityModal.name}
                                                onChange={e => onChange('name', e.target.value)}
                                                isInvalid={!!entityModal.errors?.name}
                                                className="tw-w-full tw-text-[13.5px] tw-text-slate-900 dark:tw-text-white tw-p-2 tw-px-3 tw-border tw-border-solid tw-border-slate-300 dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-outline-none focus:tw-border-blue-400 focus:tw-ring-3 focus:tw-ring-blue-500/15 tw-transition-all"
                                            />
                                            {entityModal.errors?.name && <Form.Control.Feedback type="invalid" className="tw-mt-1">{entityModal.errors.name}</Form.Control.Feedback>}
                                        </Form.Group>

                                        {/* Formula Field (KPI Only) */}
                                        {/* {type === 'kpi' && (
                                            <Form.Group className="tw-mb-0">
                                                <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1">Formula</Form.Label>
                                                <Form.Control 
                                                    type="text"
                                                    placeholder="e.g. SUM(transactions.amount)"
                                                    value={entityModal.formula || ''}
                                                    onChange={e => onChange('formula', e.target.value)}
                                                    className="tw-w-full tw-text-[13.5px] tw-text-slate-900 dark:tw-text-white tw-p-2 tw-px-3 tw-border tw-border-solid tw-border-slate-300 dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-outline-none focus:tw-border-blue-400 focus:tw-ring-3 focus:tw-ring-blue-500/15 tw-transition-all"
                                                />
                                            </Form.Group>
                                        )} */}

                                        {/* Model Type Field (Model Only) */}
                                        {type === 'model' && (
                                            <Form.Group className="tw-mb-0">
                                                <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1.5">Model type</Form.Label>
                                                <Select
                                                    classNamePrefix="select-control"
                                                    placeholder="Select Model Family"
                                                    options={MODEL_KINDS}
                                                    value={MODEL_KINDS.find(o => o.value === entityModal.kind) || null}
                                                    onChange={opt => onChange('kind', opt ? opt.value : 'Forecasting')}
                                                    styles={customSelectStyles}
                                                />
                                            </Form.Group>
                                        )}

                                        {/* Description Field */}
                                        <Form.Group className="tw-mb-0">
                                            <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1">Description (optional)</Form.Label>
                                            <Form.Control 
                                                as="textarea"
                                                rows={3}
                                                placeholder={type === 'business' ? 'What does this business represent?' :
                                                             type === 'function' ? 'What does this function represent?' :
                                                             type === 'kpi' ? 'What does this kpi represent?' : 'What does this model represent?'}
                                                value={entityModal.description || ''}
                                                onChange={e => onChange('description', e.target.value)}
                                                className="tw-w-full tw-text-[13.5px] tw-text-slate-900 dark:tw-text-white tw-p-2 tw-px-3 tw-border tw-border-solid tw-border-slate-300 dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-outline-none focus:tw-border-blue-400 focus:tw-ring-3 focus:tw-ring-blue-500/15 tw-transition-all"
                                            />
                                        </Form.Group>
                                    </div>
                            </div>

                        </div>
                    </Modal.Body>

                    {/* Footer */}
                    <div className="tw-flex tw-items-center tw-justify-end tw-py-3 tw-px-5 tw-border-0 tw-border-t tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-bg-white dark:tw-bg-white/5 tw-shrink-0 tw-gap-2">
                        <button 
                            type="button"
                            onClick={onClose} 
                            className="tw-inline-flex tw-items-center tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-lg hover:tw-bg-gray-50 dark:hover:tw-bg-[#3A3A55] tw-transition-colors"
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                        >
                            {entityModal.id ? 'Save Changes' :
                             type === 'business' ? '+ Add Business' :
                             type === 'function' ? '+ Add Function' :
                             type === 'kpi' ? '+ Add KPI' : '+ Add Model'}
                        </button>
                    </div>
                </form>
            </Modal>
        );
    }
}

EntityModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    entityModal: PropTypes.object.isRequired,
    businesses: PropTypes.array.isRequired,
    functions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
};

export default EntityModal;
